import ManageCitiesPage from './ManageCitiesPage';

export default ManageCitiesPage;
